"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getToken = exports.getToken = function getToken(tokenKey) {
  return window.sessionStorage.getItem("funke_iam_token_store_" + tokenKey) || null;
};

var hasToken = exports.hasToken = function hasToken(tokenKey) {
  return getToken(tokenKey) !== null;
};

var setToken = exports.setToken = function setToken(tokenKey, token) {
  window.sessionStorage.setItem("funke_iam_token_store_" + tokenKey, token);
};

var removeToken = exports.removeToken = function removeToken(tokenKey) {
  window.sessionStorage.removeItem("funke_iam_token_store_" + tokenKey);
};